<!-- Agent Hub - Main container for agent discovery and selection -->
<div class="agent-hub-container">

  <!-- Header Section -->
  <header class="agent-hub-header">
    <h1 class="hub-title">{{'LANDING_PAGE_H1'| translate}}</h1>
    <p class="hub-subtitle">{{'LANDING_PAGE_AGENTS_LINE'|translate}}</p>
  </header>

  <!-- Search Filter -->
  <app-search-filter
    [placeholder]="'LANDING_PAGE_SEARCH_BAR_PLACEHOLDER'|translate"
    (searchChanged)="onSearchChanged($event)">
  </app-search-filter>

  <!-- Default Agents Section (shown only when default agents exist) -->
  <div class="default-agents-section" *ngIf="hasDefaultAgents">
    <h3 class="default-section-title">{{'DEFAULT_TAG'|translate}}</h3>
    <div class="default-agents-grid">
      <app-agent-card
        *ngFor="let agent of defaultAgents; trackBy: trackByAgent"
        [agent]="agent"
        [isDefault]="true"
        [chatbotComponentRef]="chatbotComponentRef"
        [showPinIcon]="true"
        [isFavorite]="isFavorite(agent.id)"
        (unpinClicked)="onUnpinAgent($event)"
        (favoriteToggled)="onFavoriteToggled($event)"
        (infoClicked)="onInfoClicked($event)"
        (cardClicked)="onCardClicked($event)">
      </app-agent-card>
    </div>
  </div>

  <!-- Filter Tabs Row with Favorite Filter -->
  <div class="filter-row">
    <app-filter-tabs
      [categories]="categories"
      [activeCategory]="activeCategory"
      [totalCount]="totalAgentCount"
      (categoryChanged)="onCategoryChanged($event)">
    </app-filter-tabs>

    <!-- Favorite Filter Button -->
    <button
      class="favorite-filter-btn t-bottom t-no-arrow"
      [class.active]="isFavoriteFilterActive"
      (click)="onFavoriteFilterToggled(!isFavoriteFilterActive)"
      type="button"
      [attr.aria-label]="isFavoriteFilterActive ? ('SHOW_ALL_AGENTS' | translate) : ('SHOW_FAVORITE_AGENTS_ONLY_TOOLTIP' | translate)"
      [attr.aria-pressed]="isFavoriteFilterActive"
       [attr.data-tooltip]="isFavoriteFilterActive ? ('SHOW_ALL_AGENTS' | translate) : ('SHOW_FAVORITE_AGENTS_ONLY_TOOLTIP' | translate)">
      <!-- Filled Star (Active) -->
      <svg *ngIf="isFavoriteFilterActive" width="14" height="14" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8 1.33333L10.06 5.50666L14.6667 6.18L11.3333 9.42666L12.12 14.0133L8 11.8467L3.88 14.0133L4.66667 9.42666L1.33333 6.18L5.94 5.50666L8 1.33333Z" fill="currentColor"/>
      </svg>
      
      <!-- Outline Star (Inactive) -->
      <svg *ngIf="!isFavoriteFilterActive" width="14" height="14" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8 1.33333L10.06 5.50666L14.6667 6.18L11.3333 9.42666L12.12 14.0133L8 11.8467L3.88 14.0133L4.66667 9.42666L1.33333 6.18L5.94 5.50666L8 1.33333Z" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </button>
  </div>

  <!-- Loading State -->
  <div class="loading-state" *ngIf="isLoading">
    <div class="loading-spinner">
      <i class="fa fa-spinner fa-spin" aria-hidden="true"></i>
      <span>Loading agents...</span>
    </div>
  </div>

  <!-- Empty State -->
  <div class="empty-state" *ngIf="hasNoResults">
    <div class="empty-content">
      <svg class="empty-icon" width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="24" cy="24" r="20" stroke="currentColor" stroke-width="2" stroke-dasharray="4 4"/>
        <path d="M24 16V24M24 32H24.02" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
      </svg>
      <h3 class="empty-title">{{'NO_AGENTS_FOUND_HEADING'| translate}}</h3>
      <p class="empty-description" *ngIf="isFavoriteFilterActive && !searchQuery">
        {{'NO_AGENTS_FOUND_DESCRIPTION'|translate}}
      </p>
      <p class="empty-description" *ngIf="searchQuery">
        {{'NO_AGENT_MATCH'| translate}} "{{ searchQuery }}". {{'DIFF_SERCH_TERM'| translate}}
      </p>
      <p class="empty-description" *ngIf="!searchQuery && !isFavoriteFilterActive && activeCategory !== 'all'">
        {{'NO_AGENT_CATEGORY'| translate}}
      </p>
    </div>
  </div>

  <!-- Agent Cards Grid -->
  <div class="agent-cards-grid" *ngIf="!isLoading && !hasNoResults">
    <app-agent-card
      *ngFor="let agent of filteredAgents; trackBy: trackByAgent"
      [agent]="agent"
      [chatbotComponentRef]="chatbotComponentRef"
      [isFavorite]="isFavorite(agent.id)"
      (favoriteToggled)="onFavoriteToggled($event)"
      (infoClicked)="onInfoClicked($event)"
      (cardClicked)="onCardClicked($event)">
    </app-agent-card>
  </div>

</div>

<!-- Agent Info Popup -->
<app-agent-info-popup
  [agent]="selectedAgentForInfo"
  [isVisible]="showInfoPopup"
  (closed)="onInfoPopupClosed()"
  (useAgent)="onUseAgent($event)"
  (makeDefault)="onMakeDefaultAgent($event)">
</app-agent-info-popup>
